import ApiClient from "../ApiClient";

const ProductService = {

  async getProducts() {
    const resp = await ApiClient.get(`/product/products`);
    return resp;
  },
  
};

export default ProductService;
